import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("osp_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch((err) => {
        // Só descarta o token quando o SERVIDOR disse que ele não vale. Antes
        // qualquer falha derrubava a sessão — inclusive queda de rede, então um
        // F5 sem internet deslogava o operador do balcão de vez, e sem internet
        // ele também não consegue entrar de novo.
        const status = err?.response?.status;
        if (status === 401 || status === 403) localStorage.removeItem("osp_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("osp_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("osp_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("osp_token");
    setUser(null);
  };

  /**
   * Telas que o perfil do usuário libera. A mesma chave é checada na API, então
   * esconder o item do menu e recusar a chamada andam sempre juntos.
   *
   * Sem chave pedida (`can()` sem argumento) libera: itens de menu ou rotas que
   * não pertencem a nenhuma tela do catálogo continuam funcionando.
   */
  const can = (permission) => {
    if (!permission) return true;
    return (user?.permissions || []).includes(permission);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
